import { render, staticRenderFns } from "./SendForm.vue?vue&type=template&id=c8477d4c&scoped=true&"
import script from "./SendForm.vue?vue&type=script&lang=js&"
export * from "./SendForm.vue?vue&type=script&lang=js&"
import style0 from "./SendForm.vue?vue&type=style&index=0&id=c8477d4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8477d4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VProgressCircular,VTextField,VTextarea})
